/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
// import update from 'immutability-helper'

/**
 * Declare Variable
 */

/**
 * Export
 */
export const form = handleActions({
  SET_FORM: (state, action) => {
    return action.payload
  },
}, {})

export default {
  form,
}



// WEBPACK FOOTER //
// ./src/reducers/components/form.js